import { MenuItem } from '@mui/material'
import { DenyWithCommentPendingActionDialog } from 'components/pages/task/details/task-content-v2/common/DenyWithCommentPendingActionDialog'
import { TaskValue } from 'lib/actions/task'
import { useSimpleModal } from 'lib/modals'
import { FC } from 'react'
import { FormattedMessage } from 'react-intl'

type DenyWithCommentPendingDropdownOptionProps = {
    task: TaskValue
    close: () => void
}

export const DenyWithCommentPendingDropdownOption: FC<DenyWithCommentPendingDropdownOptionProps> = ({
    task,
    close,
}) => {
    const { open } = useSimpleModal()

    const handleClick = (): void => {
        if (!task.accessReview?.id) return

        open(DenyWithCommentPendingActionDialog, {
            task,
        })()
        close()
    }

    return (
        <MenuItem
            onClick={handleClick}
            key={`components_task_actions_dropdown_deny_with_comment_pending_task_${task.id}`}
        >
            <FormattedMessage id="component_task_list_deny_comment_pending_option_label" defaultMessage="Deny with comment" />
        </MenuItem>
    )
}
